import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import { Popover, Message, Backtop, Dropdown, DropdownMenu, DropdownItem ,Button, Select, Carousel, CarouselItem, Menu, MenuItem, Row, Col, Image, Dialog, Table, TableColumn, Card, Timeline, TimelineItem } from 'element-ui';

Vue.use(Menu)
Vue.use(MenuItem)

Vue.use(Button)
Vue.use(Select)
Vue.use(Carousel)
Vue.use(CarouselItem)

Vue.use(Row)
Vue.use(Col)

Vue.use(Image)

Vue.use(Dialog)

Vue.use(Table)
Vue.use(TableColumn)

Vue.use(Card)

Vue.use(Backtop)
Vue.use(Popover)
Vue.use(Timeline)
Vue.use(TimelineItem)

Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)

Vue.prototype.$message = Message;